// İSG uzmanı portalı — kapı uygunluk kontrol listesi (S32g, `docs/reviews/
// S32g-eligibility-checklist.md` §5/§6, api-contract §29.5 S32g bloğu). `MethodMarker`/
// `VerdictAvatar`'ın AYNI deseni — TEK bileşen, `VerdictCard.tsx` VE `EntryDetailModal.tsx`
// PAYLAŞIR (S32e G1'in AYNI riski: iki yüzeyin AYNI izin hakkında FARKLI şey söylemesi). Veri
// TÜRETİMİ `lib/eligibility.ts`'de (SAF); bu dosya YALNIZ render eder.
//
// **PART TWO revizyonu (aynı doküman §15-§26, owner canlı ekranı "okunması zor ve yeterince
// yapısal değil" bulduktan SONRA) — K1/K2/K3 burada kapanır:**
//   - **K1 (canlı defekt) KAPANDI.** Eksik kalemler artık KENDİ satırlarının hücresi İÇİNDE
//     render edilir — `density`'DEN BAĞIMSIZ, HER İKİ yoğunlukta (§17 madde 1). Eskiden `card`
//     yoğunluğunda kalemler `VerdictCard.tsx`'in İZİN listesiyle AYNI `<ul>`'a enjekte
//     ediliyordu; o entegrasyon SİLİNDİ (`showItemsInline` KALKTI, `EligibilityItemLine` artık
//     bu dosyanın İÇİNDE, dışa AÇILMAZ).
//   - **K2 (hairline) RETRACTED, §18.** Satır 2/3 arasındaki TEK `border-t` KALKTI — tek başına
//     bir kural hiçbir RİTİM kırmaz, sahibin okuduğu gibi "kopuk bir çizgi" olarak okunuyordu.
//     2+1 gruplaması artık YÖNLENDİRME CÜMLESİYLE (§2.1) taşınıyor, satır SIRASI (1-2-3) ücretsiz
//     kalıyor.
//   - **K3 (a11y defekti) KAPANDI, §19.** Üç satır artık TEK bir `rounded-md border
//     border-border-strong divide-y divide-border` grubu — sınır bir KENARLIK kararı, DOLGU
//     değil (§9.2'nin ret kararı DEĞİŞMEDİ, `bg-surface-muted` üzerinde `text-danger` 3.82:1
//     AA-ALTI kalıyor). Ebeveyn satır + kendi kalemleri TEK hücre (`<li>`) olarak parantezlenir
//     (§17 madde 2) — bir kalem artık İZİN listesine hiç GİREMEZ, dolayısıyla o `<ul>`'un
//     `aria-labelledby`'si her zaman DOĞRU kalır.
//   - **K7 (bu revizyonun BİR SONRAKİ turu, aynı dokümanın §2'si) — grubun DIŞ sınırı
//     `border-border-strong`'A geçti.** Canlı render'da `border-border` graphite'te 1.30:1 ölçüldü
//     (neredeyse GÖRÜNMEZ); spec §19'un belgelediği fallback UYGULANDI. YALNIZ dış sınır — satır
//     arası `divide-border` ve başka hiçbir sınır DEĞİŞMEDİ.
//
// **`density="card" | "record"`** artık YALNIZ üç şeyi ayırır: bare renkli metin fragmanı (kart,
// `permitChip`'in AYNI deseni) ya da `Badge` (modal); kalem SARMALAMASI (`truncate`+`title` vs.
// `break-words`); ve kart-YALNIZ kalem TAVANI (satır başına en çok 2 ADLANDIRILMIŞ kalem, §17 —
// şeridin ~360-370px tabanı Almanca'da 3 satır+kalemlerle taşabilir, tavan taşmayı YAPISAL olarak
// İMKANSIZ kılar; modal HİÇ sınırlamaz, `Modal` zaten kendi kaydırmasını taşır, S32d §7.3).
// Kalemler artık HER ZAMAN görünür — kartta DA — `VerdictCard.tsx` bir daha ASLA kendi izin
// listesine bir eligibility kalemi enjekte ETMEZ.
//
// **Öğe adı bir TİP/BAŞLIKTIR — tarih YOK, belge bağlantısı YOK, doğrulama durumu YOK.** Kartta
// `truncate`+`title`; modalda `break-words`, kırpılmadan (tasarım otoritesi §6.2). **Kalem
// satırı ebeveyninin kategori ikonunu TEKRARLAMAZ (R3, §17 madde 5)** — girinti + hücre sınırı
// zaten attribution'ı taşır; `sr-only` satır etiketi ÖNEKİ kalır (ekran okuyucu yolu).

import type { GateScanPermitDto } from '@isgportal/shared';
import { Tag, cn } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import {
  type EligibilityItemEntry,
  type EligibilityRow,
  eligibilityItemEntries,
  permitWindowChip,
} from '../../lib/eligibility';
import { PERMIT_CHIP_TAG_COLOR, PERMIT_CHIP_TEXT_CLASS } from '../../lib/permitWindow';

/** Kartta satır başına en çok BASILAN kalem sayısı (§17) — sayı ASLA değişmez (`statusCount` /
 *  `Eksik (N)` chip'in KENDİ satırı gerçek toplamı zaten söylüyor); yalnız hangi ADLARIN
 *  görüneceği kısılır. Modal (`record`) bu tavanı GÖRMEZ.
 *  **PART TWO §2 fallback (Option A → Option B) sonrası YÜK TAŞIYAN.** `denied`'de sıralı izin
 *  listesi geri döndüğünden kontrol listesi ve izin listesi ARTIK AYNI ~360-370px şeridi
 *  paylaşıyor (§21 Option B) — `2` bir güvenlik payı DEĞİL, taşmayı YAPISAL olarak imkânsız kılan
 *  sınırdır; `3`'e çıkarmak ölçülmeden YAPILMAZ. */
const CARD_ITEM_CAP = 2;

export interface EligibilityChecklistProps {
  /** İşaretli (`closestToEntry`) kalemin KENDİSİ — başlık + pencere çipi burada okunur. */
  permit: GateScanPermitDto;
  /** `eligibilityRows(permit)` — çağıran BİR KEZ hesaplar (routing/gösterim kararları da onu
   *  kullanır), bu bileşen yeniden TÜRETMEZ. */
  rows: EligibilityRow[];
  density: 'card' | 'record';
  className?: string;
}

/** Tek bir eksik kalem satırı — `sr-only` satır etiketi + ad, İKON YOK (§17 madde 5, R3: kalem
 *  ebeveyninin kategori ikonunu TEKRARLAMAZ, girinti + hücre attribution'ı zaten taşır). Ebeveyn
 *  satırın hücresinin İÇİNDE, HER İKİ yoğunlukta render edilir — dışa AÇILMAZ (K1 fix, §17
 *  madde 1: `VerdictCard.tsx` bir daha bunu KENDİ izin listesinde ÇAĞIRMAZ). */
function EligibilityItemLine({
  entry,
  density,
}: {
  entry: EligibilityItemEntry;
  density: 'card' | 'record';
}) {
  const { t } = useTranslation();
  const text = entry.item
    ? entry.item.kind === 'document'
      ? entry.item.label
      : entry.item.title
    : t('security.eligibility.items.unresolved');
  return (
    <span className="flex min-w-0 items-start gap-1.5 text-xs">
      <span className="sr-only">{t(entry.rowLabelKey)}: </span>
      <span
        className={cn(
          'min-w-0 flex-1',
          // §17 — adı OKUNAN cümledir, `text-fg` kalır; yalnız "adı gösterilemiyor" bir
          // meta-cümledir (`item: null`), `text-muted` [taste, madde 6.2/17].
          entry.item ? 'text-fg' : 'text-muted',
          density === 'card' ? 'truncate' : 'break-words',
        )}
        title={density === 'card' && entry.item ? text : undefined}
      >
        {text}
      </span>
    </span>
  );
}

function EligibilityRowLine({ row, density }: { row: EligibilityRow; density: 'card' | 'record' }) {
  const { t } = useTranslation();
  const CategoryIcon = row.categoryIcon;
  const StatusIcon = row.statusIcon;
  const statusText =
    row.statusCount != null
      ? t(row.statusLabelKey, { count: row.statusCount })
      : t(row.statusLabelKey);
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-1">
      {/* §17 madde 4 — ebeveyn satır etiketi `font-medium` KAZANDI (kalemin `text-xs`'iyle
          birlikte, tip ölçeğinde İKİ basamak: boyut + ağırlık). */}
      <span className="inline-flex min-w-0 flex-wrap items-center gap-1.5 text-sm font-medium text-fg">
        <CategoryIcon className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" />
        {row.srLabelKey ? (
          <>
            <span aria-hidden="true">{t(row.labelKey)}</span>
            <span className="sr-only">{t(row.srLabelKey)}</span>
          </>
        ) : (
          t(row.labelKey)
        )}
      </span>
      {density === 'card' ? (
        <span
          className={cn(
            'inline-flex shrink-0 items-center gap-1 text-xs font-medium',
            PERMIT_CHIP_TEXT_CLASS[row.tone],
          )}
        >
          <StatusIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          {statusText}
        </span>
      ) : (
        <Tag color={PERMIT_CHIP_TAG_COLOR[row.tone]} className="shrink-0 gap-1">
          <StatusIcon className="h-3 w-3 shrink-0" aria-hidden="true" />
          {statusText}
        </Tag>
      )}
    </div>
  );
}

export function EligibilityChecklist({
  permit,
  rows,
  density,
  className,
}: EligibilityChecklistProps) {
  const { t } = useTranslation();
  const windowChip = permitWindowChip(permit);
  const WindowIcon = windowChip?.icon;
  // K1 fix (§17 madde 1) — kalemler artık HER İKİ yoğunlukta, KENDİ satırlarının hücresi İÇİNDE
  // render edilir. `VerdictCard.tsx` bir daha bunları KENDİ izin listesine enjekte ETMEZ.
  const allEntries = eligibilityItemEntries(rows);

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className={cn('flex shrink-0 flex-col gap-2', className)}>
      <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-1">
        {density === 'card' ? (
          <span
            className="min-w-0 truncate text-[11px] font-semibold text-muted"
            title={permit.title}
          >
            {t('security.eligibility.eyebrow', { title: permit.title })}
          </span>
        ) : (
          <span className="min-w-0 break-words text-sm font-medium text-fg" title={permit.title}>
            {permit.title}
          </span>
        )}
        {windowChip && WindowIcon ? (
          <span
            className={cn(
              'inline-flex shrink-0 items-center gap-1 text-xs',
              PERMIT_CHIP_TEXT_CLASS[windowChip.tone],
            )}
          >
            <WindowIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
            {t(windowChip.labelKey)}
          </span>
        ) : null}
      </div>

      {/* §19 — TEK ruled grup, ÜÇ satırın tamamı: sınır bir KENARLIK kararı, DOLGU DEĞİL (`bg`
          yok, `bg-surface` kalır) — §9.2'nin ret kararı bu yüzden DEĞİŞMEZ. §18 — satır 2/3
          arasındaki ÖZEL hairline RETRACTED, yerine EVRENSEL `divide-y divide-border` geldi (aynı
          eleman parent→child hücre sınırını da taşır, §17 madde 2). Ebeveyn satır + kendi
          kalemleri TEK `<li>` hücresi — bir kalem bir daha ASLA bir kardeş listeye SIZMAZ.
          **K7 fallback (§19/§26, PART TWO §2 — canlı ekranda ÖLÇÜLDÜ):** grubun DIŞ sınırı
          `border-border-strong` (3.79:1 açık / 3.40:1 koyu) — `border-border` (1.47:1/1.30:1)
          graphite'te NEREDEYSE GÖRÜNMEZDİ. Bu YALNIZ grubun DIŞ sınırıdır; satır ARASI
          `divide-border` DEĞİŞMEDİ (K7 yalnız grubun dış sınırını hedef aldı, spec §19'daki tek
          sorudur) ve `border-border-strong` başka hiçbir yerde/anlamda GENİŞLETİLMEDİ. */}
      <ul className="flex flex-col divide-y divide-border rounded-md border border-border-strong">
        {rows.map((row) => {
          const rowEntries = allEntries.filter((entry) => entry.rowId === row.id);
          // §17 — kart tavanı (`CARD_ITEM_CAP`): şeridin ölçülü tabanını taşırmamak için ADI
          // basılan kalem sayısı kısılır, `Eksik (N)` chip'i gerçek toplamı zaten söylüyor
          // (SAYIM asla değişmez, yalnız GÖSTERİM). Modal (`record`) sınırlamaz.
          const visibleEntries =
            density === 'card' ? rowEntries.slice(0, CARD_ITEM_CAP) : rowEntries;
          return (
            <li key={row.id} className="flex flex-col gap-1 px-3 py-2">
              <EligibilityRowLine row={row} density={density} />
              {row.state === 'fail' && visibleEntries.length > 0 ? (
                <ul className="flex flex-col gap-1 pl-[1.375rem]">
                  {visibleEntries.map((entry, index) => (
                    <li key={`${row.id}-${index}`}>
                      <EligibilityItemLine entry={entry} density={density} />
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
